import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import './ProbeLogo.scss';

const IMAGE_NAME = 'account_linking_image';

const ProbeLogo = ({ alt = '', baseUrl = '', circled = false, className, siteId, small = false }) => {
  const logoUrl = `${baseUrl}/images/${siteId}/${IMAGE_NAME}.png`;
  const classes = cn(
    'cp-probe-logo',
    {
      'logo-small': small,
      'logo-circled': circled
    },
    className
  );

  return <img src={logoUrl} className={classes} alt={alt} loading="lazy" />;
};

ProbeLogo.propTypes = {
  alt: PropTypes.string,
  baseUrl: PropTypes.string,
  circled: PropTypes.bool,
  className: PropTypes.string,
  siteId: PropTypes.string.isRequired,
  small: PropTypes.bool
};

export default ProbeLogo;
